module.exports = __webpack_public_path__ + "static/img/GVMTF225KGF_FL_HIGH_V.a694a95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/GVMTF225KGF_FL_HIGH_V.jpg
// module id = vm9w
// module chunks = 0